import { t as AitisalSdk } from "../aitisal-sdk-B2mK3RTK.mjs";

//#region notification/index.ts
async function createPushSubscription(createPushSubscription) {
	return AitisalSdk.getInstance().post("notifications/push-subscription", createPushSubscription);
}
async function deletePushSubscription(endpoint) {
	return AitisalSdk.getInstance().delete("notifications/push-subscription", { data: { endpoint } });
}
async function deletePushSubscriptionByToken(token) {
	return AitisalSdk.getInstance().delete("notifications/push-subscription/token", { data: { token } });
}

//#endregion
export { createPushSubscription, deletePushSubscription, deletePushSubscriptionByToken };
//# sourceMappingURL=index.mjs.map